import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class BrandLabelReferenceService extends BaseReferenceService {
  constructor() {
    super('BrandLabelReference');
  }
}
